import React from 'react'

export default () => <span className="separator vertical" />
